
















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { add, update, details } from '@/api/router'
import { DetailsResponse } from '../index.d'

@Component({
  name: 'ChildModal'
})
export default class extends Vue {
  @Prop({ default: false }) operationDialogFlag!: boolean
  @Prop() id!: number
  @Prop() appId!: number
  @Prop() pid!: number
  private visible = false
  private formParams = {
    name: '',
    router: ''
  }

  private rules = {
    name: [{ required: true, message: '请输入路由名称', trigger: 'change' }],
    router: [{ required: true, message: '请输入路由地址', trigger: 'change' }]
  }

  private close() {
    this.$emit('update:operationDialogFlag', false);
    (this.$refs.form as ElForm).resetFields()
  }

  private onSubmit() {
    (this.$refs.form as ElForm).validate(async(valid: boolean) => {
      if (valid) {
        this.id ? await update({ ...this.formParams, id: this.id, appId: this.appId, pid: this.pid }) : await add({ ...this.formParams, appId: this.appId, pid: this.pid })
        this.id ? this.$message.success('修改成功') : this.$message.success('新增成功')
        this.$emit('onsubmit')
        this.close()
      }
    })
  }

  @Watch('operationDialogFlag')
  async handQualityDialogFlag() {
    this.visible = this.operationDialogFlag
    if (this.visible && this.id) {
      // 数据回填
      const { content } = await details<DetailsResponse>({ id: this.id })
      const { name, router } = content
      this.formParams = { ...this.formParams, name, router }
    }
  }
}
